export enum BusinessPartnerMedicalOperatorsManagementRoutes {
  List = '',
  Register = 'register',
  Details = ':medicalOperatorId',
}
